export default "__VITE_ASSET__DVzaBjTu__"